import React, { type MouseEventHandler } from "react";
import { CloseIcon } from "@/icons";
import style from "./deletePastVoteWindow.module.css";

type DeletePastVoteWindowProps = {
    name: string;
    onClose: () => void;
    onDelete: () => void;
};

export function DeletePastVoteWindow({ name, onClose, onDelete }: DeletePastVoteWindowProps) {
    const handleClose: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        onClose();
    };

    return (
        <div className={style.deletePastVoteWindowWrapper} onMouseDown={(e) => e.stopPropagation()}>
            <div className={style.deletePasteVoteWindow}>
                <div className={style.closeIconWrapper}>
                    <button
                        className={style.deletePasteVoteWindowClose}
                        type="button"
                        onMouseDown={handleClose}
                    >
                        <CloseIcon className={style.closeIcon} />
                    </button>
                </div>
                <div className={style.deletePastVoteHeader}>
                    <p>Удалить результаты?</p>
                </div>
                <div className={style.deletePastVoteTextWrapper}>
                    <p>{`Результаты «${name}» будут удалены для всех участников голосования`}</p>
                </div>
                <div className={style.deletePastVoteButtonsWrapper}>
                    <button
                        className={style.deletePastVoteBtnAccept}
                        type="button"
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            onDelete();
                        }}
                    >
                        Удалить
                    </button>
                    <button
                        className={style.deletePastVoteBtnCancel}
                        type="button"
                        onMouseDown={handleClose}
                    >
                        Отменить
                    </button>
                </div>
            </div>
        </div>
    );
}
